import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoHouse from '../assets/logo_house.svg';
import logoText from '../assets/logo_text.svg';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`fixed top-0 w-full text-purple-700 z-40 transition-all duration-300 ${
      isScrolled ? 'bg-black bg-opacity-90' : 'bg-transparent'
    }`}>
      <div className="mx-auto flex justify-between items-center p-2 md:p-4 text-xl md:text-lg xl:text-2xl">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <img src={logoHouse} alt="Logo House" className="h-14 w-14" />
            <img src={logoText} alt="Logo Text" className="h-8" />
          </Link>
        </div>
        <div className="hidden md:flex space-x-4 xl:space-x-8">
          <Link to="/" className="pink-text-hover transition-colors cursor-pointer">Home</Link>
          <Link to="/services" className="pink-text-hover transition-colors cursor-pointer">Våra Tjänster</Link>
          <Link to="/about" className="pink-text-hover transition-colors cursor-pointer">Om Oss</Link>
          {/* <Link to="/events" className="pink-text-hover transition-colors cursor-pointer">Events</Link> */}
          <Link to="/work-with-us" className="pink-text-hover transition-colors cursor-pointer">Jobb</Link>
          <Link to="/galleri" className="pink-text-hover transition-colors cursor-pointer">Galleri</Link>
          <Link to="/contact" className="pink-text-hover transition-colors cursor-pointer">Kontakta Oss</Link>

        </div>
        <button className="md:hidden focus:outline-none" onClick={toggleMenu}>
          <svg className="w-6 h-6 pink-text" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            {isOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="md:hidden bg-black bg-opacity-90 text-purple-700 p-4 space-y-4 text-2xl">
          <Link to="/" className="block pink-text-hover transition-colors cursor-pointer" onClick={toggleMenu}>Home</Link>
          <Link to="/services" className="block pink-text-hover transition-colors cursor-pointer" onClick={toggleMenu}>Våra Tjänster</Link>
          <Link to="/about" className="block pink-text-hover transition-colors cursor-pointer" onClick={toggleMenu}>Om Oss</Link>
          {/* <Link to="/events" className="block pink-text-hover transition-colors cursor-pointer" onClick={toggleMenu}>Events</Link> */}
          <Link to="/work-with-us" className="block pink-text-hover transition-colors cursor-pointer" onClick={toggleMenu}>Jobb</Link>
          <Link to="/galleri" className="block pink-text-hover transition-colors cursor-pointer" onClick={toggleMenu}>Galleri</Link>
          <Link to="/contact" className="block pink-text-hover transition-colors cursor-pointer" onClick={toggleMenu}>Kontakta Oss</Link>

        </div>
      )}
    </nav>
  );
};

export default Navbar;